export const CLEAR_LOCAL_STORAGE = "CLEAR LOCAL STORAGE"

export const RESET_CONFIG = "RESET CONFIGS";

export const EXIT_CIP = "Exit Cip";

export const GO_TO_CIP = "Go To Cip";

export const OPEN_LAUNCHER = "Open launcher";

export const NEW_BUG = "New bug";

export const HIDE_THIS_MENU = "Hide this menu";